import React, { useContext } from "react";

import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";
const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";
function ProfileCardPrism({ preview }) {
  const [cardData] = useContext(CardContext)
  const { profileImage, personalDetails, checkProfile, vCard, contactDetails } = cardData

  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";

  const handleShare = () => {
    if (navigator.share && preview) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <>
      <div className="flex justify-end mt-[60px] items-center">
        <Link
          className="flex gap-2"
          to={preview ? contactDetails?.locationUrl : ""}
          target={preview ? "_blank" : ""}
        >
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.11425 10.0068H7.1611C6.6431 10.0068 6.14631 10.2126 5.78002 10.5789C5.41374 10.9451 5.20796 11.4419 5.20796 11.9599V21.335C5.20796 21.853 5.41374 22.3498 5.78002 22.7161C6.14631 23.0824 6.6431 23.2882 7.1611 23.2882H18.88C19.398 23.2882 19.8948 23.0824 20.2611 22.7161C20.6274 22.3498 20.8331 21.853 20.8331 21.335V11.9599C20.8331 11.4419 20.6274 10.9451 20.2611 10.5789C19.8948 10.2126 19.398 10.0068 18.88 10.0068H16.9268M9.11425 6.88176L13.0205 2.97546M13.0205 2.97546L16.9268 6.88176M13.0205 2.97546V16.3057" stroke="white" strokeWidth="1.56252" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      </div>

      <div>
        <h1 className="font-normal" style={{
          width: !checkProfile ? "max-content" : "",
          fontSize: (array[0]?.length > 12 || array[1]?.length > 12 || array[2]?.length > 12) ? "35px" : "35px",
          lineHeight: "35px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}>
          {personalDetails?.name ? personalDetails.name.replace(' ', '\n') : "Name"}
        </h1>
      </div>





      <div className="flex justify-between items-center text-white">
        <div>
          <p className="border border-white border-opacity-75 pl-[16px] text-center pr-[16px] pt-[3px] pb-[3px] font-light leading-30 rounded-[28px] text-[20px] text-white "  >
            {personalDetails?.companyDesignation
              ? personalDetails.companyDesignation
              : "Designation"}
          </p>
        </div>
        <div className="flex gap-3 items-center">
          {/* <div>
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20.927" r="20" fill="white" fill-opacity="0.4" />
              <path d="M23.75 24.677H27.5V28.427H23.75V24.677ZM20.75 21.677H23.75V24.677H20.75V21.677ZM27.5 28.427H30.5V31.427H27.5V28.427ZM28.25 21.677H30.5V23.927H28.25V21.677ZM20.75 29.177H23V31.427H20.75V29.177ZM23.75 13.427H27.5V17.177H23.75V13.427Z" fill="white" />
              <path d="M30.5 20.177H20.75V10.427H30.5V20.177ZM22.8125 18.1145H28.4375V12.4895H22.8125V18.1145ZM12.5 13.427H16.25V17.177H12.5V13.427Z" fill="white" />
              <path d="M19.25 20.177H9.5V10.427H19.25V20.177ZM11.5625 18.1145H17.1875V12.4895H11.5625V18.1145ZM12.5 24.677H16.25V28.427H12.5V24.677Z" fill="white" />
              <path d="M19.25 31.427H9.5V21.677H19.25V31.427ZM11.5625 29.3645H17.1875V23.7395H11.5625V29.3645Z" fill="white" />
            </svg>
            </div> */}
          <div>
            <Link
              className=""
              onClick={() => handleTap('saveContact')}
              to={`${preview ? vCard : ""}`}
            >
              <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_b_361_103)">
                  <rect y="0.927002" width="36" height="36" rx="18" fill="white" fill-opacity="0.38" />
                  <path d="M25.5 16.927V17.427H26H27C27.1326 17.427 27.2598 17.4797 27.3536 17.5734C27.4473 17.6672 27.5 17.7944 27.5 17.927C27.5 18.0596 27.4473 18.1868 27.3536 18.2806C27.2598 18.3743 27.1326 18.427 27 18.427H26H25.5V18.927V19.927C25.5 20.0596 25.4473 20.1868 25.3536 20.2806C25.2598 20.3743 25.1326 20.427 25 20.427C24.8674 20.427 24.7402 20.3743 24.6464 20.2806C24.5527 20.1868 24.5 20.0596 24.5 19.927V18.927V18.427H24H23C22.8674 18.427 22.7402 18.3743 22.6464 18.2806C22.5527 18.1868 22.5 18.0596 22.5 17.927C22.5 17.7944 22.5527 17.6672 22.6464 17.5734C22.7402 17.4797 22.8674 17.427 23 17.427H24H24.5V16.927V15.927C24.5 15.7944 24.5527 15.6672 24.6464 15.5734C24.7402 15.4797 24.8674 15.427 25 15.427C25.1326 15.427 25.2598 15.4797 25.3536 15.5734C25.4473 15.6672 25.5 15.7944 25.5 15.927V16.927ZM21 21.427C22.1935 21.427 23.3381 21.9011 24.182 22.745C25.0259 23.5889 25.5 24.7335 25.5 25.927V26.927C25.5 27.3248 25.342 27.7064 25.0607 27.9877C24.7794 28.269 24.3978 28.427 24 28.427H10C9.60218 28.427 9.22064 28.269 8.93934 27.9877C8.65804 27.7064 8.5 27.3248 8.5 26.927V25.927C8.5 24.7335 8.97411 23.5889 9.81802 22.745C10.6619 21.9011 11.8065 21.427 13 21.427H21ZM17 9.427C18.1935 9.427 19.3381 9.90111 20.182 10.745C21.0259 11.5889 21.5 12.7335 21.5 13.927C21.5 15.1205 21.0259 16.2651 20.182 17.109C19.3381 17.9529 18.1935 18.427 17 18.427C15.8065 18.427 14.6619 17.9529 13.818 17.109C12.9741 16.2651 12.5 15.1205 12.5 13.927C12.5 12.7335 12.9741 11.5889 13.818 10.745C14.6619 9.90111 15.8065 9.427 17 9.427Z" stroke="white" />
                </g>
                <defs>
                  <filter id="filter0_b_361_103" x="-4" y="-3.073" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_361_103" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_361_103" result="shape" />
                  </filter>
                </defs>
              </svg>

            </Link>
          </div>
        </div>
      </div>




    </>

  );
}

export default ProfileCardPrism;
